import { Paper, styled } from "@mui/material";

interface Props {
  padding?: number;
  paddingTopBottom?: number;
  paddingLeftRight?: number;
}

export const PaddedPaper = styled(Paper, {
  shouldForwardProp: (prop) =>
    ["padding", "paddingTopBottom", "paddingLeftRight"].includes(
      prop.toString()
    ) === false,
})<Props>`
  padding: ${({ theme, padding = 2, paddingTopBottom, paddingLeftRight }) =>
    theme.spacing(paddingTopBottom || padding, paddingLeftRight || padding)};
`;
